import { FunctionComponent, useContext, useState } from "react";
import { TransferContext } from "../../../context/TransferContext";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import Flex from "../../../layout/flex";
import TransferStatusTile from "../../../components/transfer-status-tile";
import convertTransferStatus from "../../../utils/convertTransferStatus";
import { NewTransferStatusType, TransferInstruction } from "../../../class/transferInstruction";
import Footer from "../../../components/footer";
import DestinationAccount, { AccountType, DestinationAccountResponse } from "../../../class/destinationAccount";
import NotificationBar from "../../../components/notification-bar";
import { STEP_SCHEDULE_PHONE_CALL } from "../../../class/transferDetails";
import { HeadlineMedium, Highlight, LabelMedium, TitleMedium } from "../../../components/font";
import { TileContainer, TransferContinueCard } from "./styles";
import { Button } from "@manifesthhqinc/ui-library";
import HeadingContainer from "../../../layout/heading-container";
import { OptionFormContainer } from "../../../layout/container/OptionFormContainer";

const getTransferToString = (data: DestinationAccount | DestinationAccountResponse): string => {
  const isEmployerSponsoredPlan = data.destinationAccountType === AccountType.employerSponsored;
  return `${data.providerName ? `${data.providerName} - ` : ""} ${isEmployerSponsoredPlan ? data.planSponsor : "IRA"}`;
};

const HomeScreen: FunctionComponent = () => {
  const {
    transferDetails,
    userDetails,
    goToScreen,
    setShouldShowHomeScreen,
    transferInstructions,
    clickClose,
    onClickContinueTransfer,
    getTransferProgressText,
  } = useContext(TransferContext);
  const [showNoteBar, setShowNoteBar] = useState<boolean>(true);

  // const onClickContinue = () => {
  //   const incompleteSourceAccount = transferDetails.sourceAccounts.filter((s: SourceAccount) => !s.isCompleted)[0];

  //   if (incompleteSourceAccount) {
  //     setCurrentOldAccount(incompleteSourceAccount);
  //   }
  //   goToScreen(transferDetails.currentStep);
  //   setShouldShowHomeScreen(false);
  // };

  // const onClickRemoveButton = ({ sourceAccountId }: { sourceAccountId: SourceAccount["sourceAccountId"] }) => {
  //   setShowRemovePopup(true);
  //   setSourceAccountToBeRemoved(sourceAccountId);
  // };

  // const confirmRemoveAccount = async () => {
  //   if (sourceAccountToBeRemoved === -1) return;
  //   await removeSourceAccount(sourceAccountToBeRemoved);
  //   setShowRemovePopup(false);
  // };

  if (transferInstructions.length > 0) {
    return (
      <>
        <ScrollableContainer name="home-screen">
          <Container>
            {transferInstructions.filter(
              (s) => s.transferInstructionStatus === NewTransferStatusType.SCHEDULE_PHONE_CALL,
            ).length > 0 && (
              <NotificationBar show={showNoteBar} closeNote={() => setShowNoteBar(false)}>
                Your provider requires a phone call. Schedule a call with your transfer specialist.{" "}
                <button
                  onClick={() => {
                    setShouldShowHomeScreen(false);
                    goToScreen(STEP_SCHEDULE_PHONE_CALL);
                  }}
                >
                  Schedule a call
                </button>
              </NotificationBar>
            )}
            <HeadingContainer paneVariant="list" withProgressBar={false}>
              <HeadlineMedium>
                Hi <Highlight>{userDetails.firstName}</Highlight>, here are your transfers
              </HeadlineMedium>
            </HeadingContainer>
            <OptionFormContainer>
              {transferInstructions.map((transferInstruction: TransferInstruction) => (
                <TransferStatusTile
                  key={transferInstruction.transferInstructionId}
                  status={convertTransferStatus(transferInstruction)}
                  from={transferInstruction.source.planSponsor || ""}
                  to={getTransferToString(transferInstruction.destinations[0])}
                  description={transferInstruction.transferExternalStatusDescription}
                />
              ))}
            </OptionFormContainer>
          </Container>
        </ScrollableContainer>
        <Footer>
          <Button name="exit-manifest" onClick={clickClose} size="large" variant="secondary">
            Exit Manifest
          </Button>
        </Footer>
      </>
    );
  }

  return (
    <>
      <ScrollableContainer name="home-screen">
        <Container>
          <HeadlineMedium>
            Hi <Highlight>{userDetails.firstName}</Highlight>, here's your transfer:
          </HeadlineMedium>
          <TileContainer>
            <TransferContinueCard>
              <Flex $flexDirection="column" $flexGap={8} $alignItems="flex-start">
                <TitleMedium>Continue your transfer</TitleMedium>
                <LabelMedium>
                  <Highlight>Next up</Highlight> | {getTransferProgressText(transferDetails)}
                </LabelMedium>
              </Flex>
              <Button name="Continue" onClick={onClickContinueTransfer}>
                Continue
              </Button>
            </TransferContinueCard>
          </TileContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="exit-manifest" onClick={clickClose} size="large" variant="secondary">
          Exit Manifest
        </Button>
      </Footer>
    </>
  );
};
export default HomeScreen;
